export default "__VITE_ASSET__CefHt6Hm__"